'use client';

import React from 'react';
import { UserAnalyticsContext } from './UserAnalyticsContext';
import { useUserAnalytics } from './useUserAnalytics';

interface UserAnalyticsProviderProps {
  children: React.ReactNode;
}

export const UserAnalyticsProvider: React.FC<UserAnalyticsProviderProps> = ({
  children,
}) => {
  const analytics = useUserAnalytics();

  return (
    <UserAnalyticsContext.Provider value={analytics}>
      {children}
    </UserAnalyticsContext.Provider>
  );
};

export default UserAnalyticsProvider;
